export const removeKeysWithValueOf = (subject, notAllowedValue) =>
  Object.fromEntries(
    Object.entries(subject).filter(([, value]) => value !== notAllowedValue)
  );
